import { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useEscalateUnpaidInvoiceMutation } from '../../../api/gql';
import { ContactsSupport } from '../../../components/ContactsSupport';
import { notify } from '../../../utils/notification';

type Props = {
  invoiceId: string;
  transNs?: string;
  keyPrefix?: string;
};

export const EscalateDialogModule = ({
  transNs = 'page-invoice-detail',
  keyPrefix = 'escalation',
  invoiceId,
}: Props) => {
  const { t } = useTranslation(transNs, { keyPrefix });
  const [message, setMessage] = useState(t('dialog.messageTemplate'));
  const { mutate, isPending } = useEscalateUnpaidInvoiceMutation({
    onSuccess: () => {
      notify.positive({
        message: t('dialog.mutation.success'),
      });
    },
    onError: (error) => {
      console.error(error);
      notify.negative({ message: t('dialog.mutation.error') });
    },
  });

  const sendMessage = () => {
    if (!message) {
      return;
    }
    mutate({ input: { invoiceId, message } });
  };

  return (
    <>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Stack gap={3}>
          <Typography variant={'body2'} textAlign={'center'} gutterBottom>
            {t('dialog.sendUsAMessage')}
          </Typography>
          <TextField
            multiline
            rows={3}
            label={t('dialog.message')}
            error={!message}
            helperText={!message ? t('dialog.validation.error') : ''}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <LoadingButton loading={isPending} variant={'contained'} onClick={sendMessage} disabled={!message}>
            {t('dialog.sendMessage')}
          </LoadingButton>
        </Stack>
        <Stack>
          <Divider />
        </Stack>
        <Stack>
          <Typography variant={'body2'} textAlign={'center'}>
            {t('dialog.orContactUs')}
          </Typography>
          <ContactsSupport sx={{ border: 0 }} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button fullWidth component={Link} to={'..'}>
          {t('cancel')}
        </Button>
      </DialogActions>
    </>
  );
};
